module.exports = __webpack_public_path__ + "img/02daa407ebf2852d208fbd70968026d.png";